import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

const BASE_URL = `/analysis`;

const AnalysisService = {
    analysisStatistics: (): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/analysisStatistics`);
    },
};

export default AnalysisService;